<template>
  <div class="sign_in">

    <div class="signinf">
      <div class="info">
        <h1>
          <img src="../assets/logo_47x37.png" />
          <span>运友邦运输管理系统</span>
        </h1>

        <!-- <el-tabs v-model="activeName" stretch>
          <el-tab-pane label="手机号登录" name="first">
            <el-form class="entry" ref="loginForm1" :model="form1" :rules="rules" label-position="top">
              <el-form-item prop="phone" label="手机号">
                <el-input placeholder="请在此输入手机号" v-model="form1.phone">
                </el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码">
                <el-input placeholder="请在此输入验证码" v-model="form1.code">
                  <template #suffix>
                    <el-button :class="[showCode ? 'cb' : 'cbs']" @click="getCode">
                      <span>{{ btnTitle }}</span>
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" class="subbtn" @click="loginValidate1('loginForm1')">登录</el-button>
          </el-tab-pane>
          <el-tab-pane label="用户名登录" name="second"> -->
            <el-form class="entry" ref="loginForm" :model="form" :rules="rules" label-position="top">
              <el-form-item prop="username" label="用户名">
                <el-input placeholder="请在此输入用户名" v-model="form.username">
                </el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input placeholder="请在此输入密码" v-model="form.password" show-password>
                </el-input>
              </el-form-item>
              <el-form-item v-show="showYzm" class="yzm" prop="yzm" label="验证码">
                <el-input placeholder="请在此输入验证码" v-model="form.yzm">
                </el-input>
                <div class="code" ref="yzm" @click="freshCode">
                  <img :src="`${IP}${yzmUrl}`" />
                </div>
              </el-form-item>
            </el-form>

            <el-button type="primary" class="subbtn" @click="loginValidate('loginForm')">登录</el-button>
          <!-- </el-tab-pane>
        </el-tabs> -->

        <div class="tips">运友邦TMS 版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Login",
  props: {
    msg: String,
  },
  data() {
    return {
      yzmUrl: '/fleet/login/captcha',
      showYzm: false,
      form: {
        username: null,
        password: null,
        yzm: 'dycdl',
      },
      form1: {
        phone: null,
        code: null,
      },
      btnTitle: '获取验证码',
      rules: {
        username: [{ required: true, message: "请填写用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请填写手机号", trigger: "blur" }],
        code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
        // yzm: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      },
      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveState: false /*触发拖动状态  判断*/,
      maxWidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: "按住滑块，拖动到最右边" /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      activeName: 'first',
      isClick: true,
      showCode: true
    };
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    loginValidate1(fname) {
      console.log({ ...this.form1 });
      // console.log(this.$refs);
      this.$refs[fname].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.logReq1()
        }
      });
    },
    logReq1() {
      this.post('login/dologin', this.form1, ({ user, msg }) => {
        if (user && user.id) {
          console.log({ ...user });
          this.setUserInfo(user);
          let path = 'index'
          const { user_group_id } = user
          if ([2, 3, 4].includes(user_group_id)) {
            // 主管会计、分管会计、出纳
            path = 'order'
          } else if (user_group_id == 5) {
            path = 'order'
          } else if (user_group_id == 6) {
            path = 'fix'
          } else if (user_group_id == 7) {
            path = 'vehicle'
          }
          this.$nextTick(() => {
            this.$router.push(path)
          })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      })
    },
    getCode() {
      if (!this.form1.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号!',
        });
        return
      }
      if (!/^[1]([3-9])[0-9]{9}$/.test(this.form1.phone)) {
        this.$message({
          type: 'error',
          message: '请填写正确的手机号!',
        });
        return
      }
      if (this.isClick) {
        this.post('login/getcode', { phone: this.form1.phone }, ({ msg }) => {
          if (msg == 'ok') {
            this.showCode = false
            console.log(111)
            this.isClick = false
            let s = 60
            this.btnTitle = s + 's'
            let interval = setInterval(() => {
              s--
              this.btnTitle = s + 's'
              if (s < 0) {
                this.btnTitle = '重新获取'
                this.isClick = true
                clearInterval(interval)
              }
            }, 1000);
            // console.log(res)
          } else {
            this.$message({
              type: 'error',
              message: msg,
            });
          }
        })
      }
    },
    loginValidate(fname) {
      console.log({ ...this.form });
      // console.log(this.$refs);
      this.$refs[fname].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.logReq()
        }
      });
    },
    logReq() {
      this.post('login/dologin', this.form, ({ user, msg }) => {
        if (msg == 'success' && user && user.id) {
          console.log({ ...user });
          this.setUserInfo(user);
          let path = 'admin/index'
          const { user_group_id } = user
          if (![1].includes(user_group_id)) {
            path = 'admin/welcome'
          }
          this.$nextTick(() => {
            this.$router.push(path)
          })
        } else if (msg.includes('离职') || msg.includes('冻结')) {
          this.$message({
            type: 'error',
            message: msg,
          });
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          this.form.yzm = ''
          this.showYzm = true
        }
      })
    },
    freshCode() {
      const url = this.yzmUrl
      this.yzmUrl = ''
      this.$nextTick(() => {
        this.yzmUrl = url
      })
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
@vw: 100vw / 1920;
@vh: 100vh / 1080;

.sign_in {
  position: relative;
  z-index: 99;
  height: 100vh;
  background: url(../assets/login_bg.png) no-repeat bottom center;
  /* background-size: 100%; */
  background-size: cover;

  .signinf {
    position: absolute;
    right: calc(210 * @vw);
    top: calc(106 * @vw);
    width: 640px;
    height: 689px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 19px 39px 1px #DEE1FF;
    border-radius: 30px;

    .info {
      width: 400px;
      height: auto;
      overflow: hidden;
      margin: 0 auto;

      h1 {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 28px;
        color: #2A1E17;
        margin: 50px auto;

        img {
          margin-right: 20px;
        }
      }

      /deep/ .el-tabs {
        .el-tabs__header {
          .el-tabs__item {
            font-weight: bold;
            font-size: 15px;
            padding: 0;
            height: 50px;

            &.is-active {
              color: #3E82FE;
            }
          }
        }
      }

      .entry {
        /deep/ .el-form-item {
          margin-bottom: 10px;

          .el-form-item__label {
            color: #2A1E17;
            padding: 0;

            &::before {
              display: none;
            }
          }

          .el-form-item__content {
            .el-input {
              .el-input__inner {
                border: 0 none;
                height: 50px;
                padding: 0 20px;
                background: #F5F5F5;
              }
            }

            .el-input__suffix {
              display: flex;
              align-items: center;
            }
          }
        }

        .yzm {
          /deep/ .el-form-item__content {
            display: flex;

            .code {
              width: 250px;
              height: auto;
              margin-left: 20px;
              display: flex;
              cursor: pointer;

              img {
                width: 100%;
                align-self: center;
              }
            }
          }
        }
      }

      .subbtn {
        display: block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        overflow: hidden;
        margin: calc(70 * @vh) auto 0;
        padding: 0;
        border-radius: 5px;
        font-size: 16px;
        color: #fff;
        background: #4487EC;
      }

      .tips {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #9FB4D9;
        position: absolute;
        bottom: calc(35 * @vh);
        left: 0;
      }
    }
  }
}
</style>